import { render, staticRenderFns } from "./embeddablesForm.vue?vue&type=template&id=37f1d5da"
import script from "./embeddablesForm.vue?vue&type=script&lang=js"
export * from "./embeddablesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.94.0__lodash@4.17.21__ar4y5aobbfwjol7cdxadoh6aqe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports